
<div class="card">
  <div class="card-header px-3 py-2">
    <div class="card-header-title">
      <span class="font-weight-bold">Firms</span>
    </div>
    <button 
      type="button"
      class="btn btn-sm btn-outline-secondary new-firm"
      :title="table.title(`add`)"
      v-on:click="table.click(`add`)"
    >
      <i class="fas fa-plus-square mr-2"></i>
      <span>Add</span>
    </button>
  </div>
  <div>
    <div class="card-body">
      <search :o="table"></search>
      <div class="firms-list">
        <scroll-area class="pr-3">
          <table class="table table-sm">
            <tbody>
              <tr v-for="(o, i) in table.items" :key="i" class="firm">
                <td>
                  <i
                    class="fas fa-building mr-1"
                    :title="table.title(`edit`)"
                    v-on:click="table.click(`edit`, o)"
                  ></i>
                  <a
                    href="#"
                    class="badge badge-light"
                    :title="table.title(`view`)"
                    v-on:click="table.click(`view`, o)"
                    v-text="o.name"
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
        </scroll-area>
      </div>
    </div>
  </div>
</div>
